import { render, staticRenderFns } from "./tabs-Endorsement.vue?vue&type=template&id=0d1ab728&scoped=true&"
import script from "./tabs-Endorsement.vue?vue&type=script&lang=js&"
export * from "./tabs-Endorsement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ab728",
  null
  
)

export default component.exports